import React, { Component, Fragment } from "react";
import Dashboard from "./common/Dashboard";
import AppLoader from "./common/AppLoader";
import Notification from "./common/Notification";
import Login from "./common/Login";
import { Router } from "@reach/router";
import AuthRoutes from "./common/AuthRoutes";
import VimeoPlayer from "./common/VimeoPlayer";
import ResetPassword from "./common/ResetPassword";
import AlertDialog from "./common/AlertDialog";

class App extends Component {
  render() {
    return (
      <Fragment>
        <AppLoader />
        <AlertDialog />
        <Notification />
        <Router>
          <Login path="/login" default />
          <ResetPassword path="/resetPassword" />
          <AuthRoutes path="main">
            <Dashboard path="/">
              <VimeoPlayer path="video/:videoKey" />
            </Dashboard>
          </AuthRoutes>
        </Router>
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js